import { useContext } from 'react'
import { SavedPropertiesContext } from '../context/SavedPropertiesContext.js'

export const useSavedProperties = () => useContext(SavedPropertiesContext)
